import { isPlatformBrowser } from '@angular/common';
import { Component, Input, HostListener } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { ModalController, Platform } from '@ionic/angular';
import { EvmTransactionData } from '@moralisweb3/evm-utils';

@Component({
  selector: 'app-transaction-detail-moralis-modal',
  templateUrl: './transaction-detail-modal.component.html',
  styleUrls: ['./transaction-detail-modal.component.scss'],
})
export class TransactionDetailMoralisModalComponent {
  @Input() transaction: EvmTransactionData;
  @Input() blockExplorerUrl: string;
  options: InAppBrowserOptions = {
    location: 'no', // Or 'no'
    hidden: 'no', // Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', // Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', // Android only
    closebuttoncaption: 'Close', // iOS only
    toolbar: 'yes', // iOS only
    toolbarposition: 'top', // iOS only
    enableViewportScale: 'no', // iOS only
    allowInlineMediaPlayback: 'no', // iOS only
    presentationstyle: 'fullscreen', // iOS only
    fullscreen: 'yes', // Windows only
  };

  constructor(private modalController: ModalController, private platform: Platform, private inappBrowser: InAppBrowser) {}

  dismissModal() {
    this.modalController.dismiss();
  }

  @HostListener('click', ['$event.target'])
  async copyTransactionId() {
    await navigator.clipboard.writeText(this.transaction.hash);
  }

  openUrlToExplorer() {
    if(isPlatformBrowser(this.platform)) {
      window.open(this.blockExplorerUrl, '_blank');
    } else {
      this.platform.ready().then(() => {
        this.inappBrowser.create(this.blockExplorerUrl, '_system', this.options);
      });
    }
  }
}
